import { API } from "aws-amplify";
import config from '../config.json';
import { OffLineAPI } from '../offline-auth/api';

var _API = config.isOffline ? OffLineAPI : API;

export function getUsers(name, searchKey, token, limit, filterDate, days) {
    let query = `consultRole=${name}`;
    if (name === 'doctor') {
        query += `&filterDate=${filterDate}`
        query += `&days=${days}`
    }
    if (token !== null) {
        token ? token = JSON.stringify(token) : token = '';
        query += `&token=${token}`;
    }
    if (searchKey != null) {
        query += `&searchKey=${searchKey}`;
    }
    query += limit ? `&limit=${limit}` : `&limit=10`
    return _API.get("users", `/users?${query}`);
}

export function getUsersBySub(name, userId, searchKey, token, limit) {
    let query = `consultRole=${name}`;
    query += `&userId=${userId}`;
    if (token !== null) {
        token ? token = JSON.stringify(token) : token = '';
        query += `&token=${token}`;
    }
    if (searchKey != null) {
        query += `&searchKey=${searchKey}`;
    }
    query += limit ? `&limit=${limit}` : `&limit=10`
    return _API.get("users", `/userlistbysub?${query}`);
}
export function getClinics() {
    let query = `consultRole=clinic`;
    //  query += limit ? `&limit=${limit}` : `&limit=10`
    return API.get("users", `/userslist?${query}`);
}
export function getUserDetails(id) {
    return _API.get("users", `/userdetails?userId=${id}`);
}

export function updatProfilePic(body) {
    return _API.post("users", `/profilepic`, { body })
}
export function createPatient(body) {
    return _API.post("users", `/createpatient`, { body })
}

export function updateProfile(body) {
    return _API.put("users", `/updateconsultuser`, { body })
}
export function deletePatient(body) {
    return _API.post("users", `/deleteuser`, { body })
}

export function adminDashboard() {
    return _API.get("admin", `/admindashboard`)
}
export function adminUserReport() {
    return _API.get("admin", `/adminuserreport`)
}
export function clinicUserReport() {
    return _API.get("admin", `/clinicuserreport`)
}
export function adminAppointmentReport() {
    return _API.get("admin", `/adminappointmentreport`)
}

//dheeraj

export function adminAppointmentStatusReport() {
    return _API.get("admin", `/adminapptstatusreport`)
}


//dheeraj

export function clinicAppointmentReport() {
    return _API.get("admin", `/clinicappointmentreport`)
}
export function createUser(body) {
    return _API.post("admin", `/usersignup`, { body })
}

export function adminDoctorReport(state, city, from, to, token, limit) {
    let query = `stateName=${state}&city=${city}`;
    query += `&from=${from}&to=${to}`;
    if (token !== '' && token !== null) {
        token ? token = JSON.stringify(token) : token = '';
        query += `&token=${token}`;
    }
    query += limit ? `&limit=${limit}` : `&limit=10`
    return _API.get("admin", `/admindoctorreport?${query}`)
}

export function adminAppointmentReports(role, from, to, token, limit) {
    let query = `role=${role}`;
    query += `&from=${from}&to=${to}`;
    if (token !== '' && token !== null) {
        token ? token = JSON.stringify(token) : token = '';
        query += `&token=${token}`;
    }
    query += limit ? `&limit=${limit}` : `&limit=10`
    return _API.get("admin", `/adminappointmentreportbyrole?${query}`)
}
export function updateUser(id, body) {
    return _API.put("admin", `/updateuser/${id}`, { body })
}

export function deleteUser(body) {
    // console.log("body======", body);
    return _API.post("admin", `/deleteuser`, { body })
}
export function getDoctorUploadFiles() {
    return _API.get("users", `/doctoruploadlist`)
}
export function getDoctorFiles(id) {
    return _API.get("users", `/doctoruploadlist?userId=${id}`)
}

export function deletewaitingroomupload(body) {
    return _API.post("users", `/deletewaitingroomupload`, { body })
}

export function patientsignup(body) {
    return _API.post("users", `/patientsignup`, { body })
}

export function logout() {
    return _API.get("users", '/logout');
}

export function createroom(body) {
    // let body = {
    // roomName: 'testfordemo',
    // roomOptions: {
    //     inputLimit : 10,
    //     participantLimit : 10,
    // },
    // roomType: 'C',
    // userEmail: 'venkatesh.t@peoplelinkvc.com',
    // expireAt: 1639035099641

    // }
    return _API.post("admin", `/createroom`, { body })
}
export function login(body) {
    return _API.post("users", `/login`, { body });
}

export function currentsession() {
    return _API.get("users", `/currentsession`);
}

export function currentuserinfo() {
    return _API.get("users", `/currentuserinfo`);
}

export function getallClinics() {
    let query = `consultRole=clinic`;
    //  query += limit ? `&limit=${limit}` : `&limit=10`
    return _API.get("users", `/listallclinics?${query}`);
}

export function changepasword(body) {
    return _API.put("users", `/changepassword`, { body })
}

export function verifyuser(body) {
    return _API.post("admin", `/verifyuser`, { body })
}

export function validateSignup(body) {
    return _API.post("users", `/validatesignup`, { body })
}

export function resendSignup(body) {
    return _API.post("users", `/resendotp`, { body })
}
export function forgotPassword(body) {
    return _API.post("users", `/sendotp`, { body })
}
export function forgotPasswordSubmit(body) {
    return _API.post("users", `/validateotp`, { body })
}
export function getStates() {
    return _API.get("users", `/statelist`);
}
export function getCities() {
    return _API.get("users", `/citieslist`);
}

export function getBloodGroupList() {
    return _API.get("users", `/bloodgrouplist`);
}
export function getDepartmentList() {
    return _API.get("users", `/departmentlist?app=${config.app}`);
}
export function getDiseasesList() {
    return _API.get("users", `/diseaseslist?app=${config.app}`);
}
export function getDiagonisisList() {
    return _API.get("users", `/diagonisislist`);
}

export function getQualificationList() {
    return _API.get("users", `/qualificationlist?app=${config.app}`);
}
export function getSpecializationList() {
    return _API.get("users", `/specializationlist?app=${config.app}`);
}
export function deleteProfilePic(body){
    return _API.post("users", '/profilepicdelete', {body})
}

export function getDoctorList(name, filterDate, from, fromTime, to, days, token, clinicId, limit = 10) {
    let query = filterDate ? `consultRole=${name}&filterDate=${filterDate}` : `consultRole=${name}`;
    query += `&limit=${limit}&from=${from}&fromTime=${fromTime}&to=${to}&days=${days}&clinicId=${clinicId}`;
    query += token && token !== null && token !== '' ? `&token=${JSON.stringify(token)}` : '';
    return _API.get("users", `/users?${query}`);
}

export function getDepartmentAndPSecialist() {
    return _API.get("users", `/deptAndspec`);
}

export function addDepartmentAndPSecialist(body) {
    return _API.post("users", `/deptAndspec`, { body });
}
